<template>
    <div class="matchList">
        <Header></Header>
        <div class="container">
            <div class="match_ing">
                <div class="match_ing_title">
                    <span class="match_ing_title_title">
                        <svg-icon icon-class="robot"/>
                        征集中
                    </span>
                    <!-- <span class="to_hold">我要办赛</span> -->
                </div>
                <div class="match_ing_content">
                    <div
                     class="match_card"
                     v-for="(item, index) in matchList"
                     :key="index"
                     @click="goDeatil(item.id)">
                        <div class="coverBox">
                            <img :src="item.cover" alt="">
                        </div>
                        <div class="card_content">
                            <span>
                                <span class="match_card_type">{{ item.type }}</span>
                                - {{ item.name }}
                            </span>
                            <span class="endTime">
                                结束时间：{{ item.matchEndTime }}
                            </span>
                        </div>
                    </div>
                    <span class="default" v-if="!matchList.length">
                        <img src="@/assets/icon/notdata.png" alt="">
                        暂时没有赛事
                    </span>
                </div>
            </div>
            <div class="match_finish">
                <div class="match_finish_title">
                    <svg-icon icon-class="end"/>
                    已结束
                </div>
                <div class="worksTab">
                    <span
                     :class="worksTab == item? 'active' : ''"
                     v-for="(item, index) in wroksTabList"
                     :key="index"
                     @click="changeMatchTab(item)">{{ item == ''? '全部' : item }}</span>
                    <div class="worksSearch">
                        <el-input placeholder="请输入内容" v-model="searchContent" @keyup.enter.native="getmatchWorksList" class="input-with-select">
                            <el-button slot="append" @click="getmatchWorksList" icon="el-icon-search"></el-button>
                        </el-input>
                    </div>
                </div>
                <div
                 class="matchDetail"
                 v-for="(item, index) in matchListEnd"
                 :key="index">
                    <img class="matchCover" @click="goDeatil(item.id)" :src="item.cover" alt="">
                    <div class="matchDetail_content">
                        <div class="matchDetail_title">
                            <span class="match_name">{{ item.name }}</span>
                            <div class="matchDetail_content_content">
                                <span class="match_time">{{ `${item.matchStartTime} 至 ${item.matchEndTime}` }}</span>
                                <span class="match_works_num_box">
                                    <span class="match_works_num">参赛作品</span>
                                    {{ item.worksList? item.worksList.length : 0 }}
                                </span>
                            </div>
                        </div>
                        <div class="worksListBox" v-if="item.worksList">
                            <div
                             class="match_works"
                             v-for="(worksItem, worksIndex) in item.worksList"
                             :key="worksIndex"
                             @click="$router.push(`matchWorks/${worksItem.id}`)">
                                <img class="works_cover" :src="worksItem.cover? worksItem.cover : worksItem.workPictureList[0]"  alt="">
                                <div class="works_info">
                                    <img class="user_avatar" :src="worksItem.authorAvatar" alt="">
                                    <span class="user_authorName">{{ worksItem.authorName }}</span>
                                    <span class="works_name">{{ worksItem.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="default" v-if="!matchListEnd.length">
                    <img src="@/assets/icon/notdata.png" alt="">
                    暂时没有相关数据
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/header.vue';
import matchApi from '@/request/api/match';
import communityApi from '@/request/api/community';
export default {
    components: { Header },
    computed: {
        themeData() {
            return this.$store.state.themeData;
        }
    },
    data() {
        return {
            searchContent: "",
            matchList: [],
            matchListEnd: [],
            worksTab: "",
            wroksTabList: ['', '国赛', '省赛', '市赛', '官方赛']
        }
    },
    created() {
        this.getmatchList();
        this.getmatchWorksList();
    },
    methods: {
        //获取竞赛项目列表
        getmatchList() {
            matchApi.matchs(this.themeData.id, res => {
                if(res.succeed) {
                    this.matchList = res.data;
                }
            });
        },
        //获取赛事详情列表
        getmatchWorksList() {
            let params = {
                "institutionId": this.themeData.id,
                "name": this.searchContent,
                "pageNumber": 1,
                "pageSize": 3,
                "sortDirection": 0,
                "sortName": "createDate",
                "startDate": "",
                "endDate": "",
                "status": "过期",
                "type": this.worksTab
            };
            matchApi.matchList(params, res => {
                if(res.succeed) {
                    this.matchListEnd = res.data.content;
                    this.matchListEnd.forEach((item, index) => {
                        this.getworksList(item.id, index);
                    })
                }
            })
        },
        //获取作品列表
        getworksList(id, index) {
            let params = {
                name: this.search,
                pageNumber: 1,
                pageSize: 8,
                sortDirection: 1,
                sortName: "",
                status: "已发布",
                institutionId: this.themeData.id,
                matchId: id,
                matchItemId: "",//所属赛项
                allType: 1, //给全部类型作品
            }
            communityApi.worksListByType(params, res => {
                if(res.succeed) {
                    this.$set(this.matchListEnd[index], 'worksList', res.data.content);
                }
            })
        },
        changeMatchTab(item) {
            this.worksTab = item;
            this.getmatchWorksList();
        },
        goDeatil(id) {
            let routeUrl = this.$router.resolve({
                path: '/matchDetail',
                query: { id }
            })
            window.open(routeUrl.href, '_blank');
        },
    },
}
</script>
<style scoped>
.matchList {
    font-family: Source Han Sans CN;
    background-color: #F3F5F7;
}
.match_ing,
.match_finish {
    padding: 10 0;
    margin-bottom: 50px;
}
.match_finish {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.match_ing_title {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
}
.match_ing_title .to_hold {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #67c23a;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
}
.match_ing_title_title,
.match_finish_title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 250px;
    color: var(--theme-color);
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 3px;
    padding: 7px 0;
    border-bottom: 1px solid #aaa;
}
.match_ing_title_title .svg-icon,
.match_finish_title .svg-icon {
    width: 47px;
    height: 47px;
    color: var(--theme-color);
    margin-right: 15px;
}
.match_ing_content {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
.match_ing_content .match_card {
    width: 49%;
    margin-bottom: 30px;
    background-color: #fff;
    border-radius: 3px;
    overflow: hidden;
    cursor: pointer;
}
.match_ing_content .coverBox {
    width: 100%;
    max-height: 270px;
    overflow: hidden;
}
.match_ing_content .match_card img {
    width: 100%;
    max-height: 270px;
}
.card_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #000;
    font-size: 16px;
    padding: 15px;
}
.card_content .endTime {
    display: block;
    color: #bbb;
    font-size: 14px;
    padding: 5px 0;
}
.card_content .match_card_type {
    color: #fff;
    padding: 5px 15px;
    border-radius: 5px;
    background-color: var(--theme-color);
}
.match_finish .worksTab {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px 0;
}
.match_finish .worksTab span {
    color: #999;
    font-size: 19px;
    font-weight: 600;
    margin: 15px;
    cursor: pointer;
}
.match_finish .worksTab span.active {
    color: var(--theme-color);
}
.match_finish .worksSearch {
    /* position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%); */
    width: 200px;
}
.match_finish .matchDetail {
    width: 100%;
    background-color: #fff;
    margin: 8px 0;
    border-radius: 3px;
    overflow: hidden;
}
.match_finish .matchDetail .matchDetail_title {
    padding: 10px 0;
    border-bottom: 1px solid #ccc;
}
.match_finish .matchDetail .matchDetail_title .match_name {
    color: #000;
    font-size: 18px;
    font-weight: 600;
}
.match_finish .matchDetail .matchDetail_title .matchDetail_content_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.matchDetail_content_content .match_time {
    color: #bbb;
}
.matchDetail_content_content .match_works_num_box {
    color: var(--theme-color);
    font-size: 15px;
}
.matchDetail_content_content .match_works_num {
    display: inline-block;
    color: #fff;
    padding: 3px 10px;
    background-color: var(--theme-color);
    border-radius: 20px;
}
.match_finish .matchDetail .matchCover {
    min-width: 100%;
    height: 240px;
    overflow: hidden;
    cursor: pointer;
}
.matchDetail .matchDetail_content {
    padding: 20px;
}
.matchDetail_content .worksListBox {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
}
.matchDetail_content .worksListBox .match_works {
    display: flex;
    flex-direction: column;
    width: 23%;
    color: var(--theme-color);
    font-size: 15px;
    font-weight: 600;
    padding: 0 1%;
    margin: 10px;
}
.match_works .works_cover {
    max-width: 100%;
    height: 174px;
}
.match_works .works_info {
    padding: 7px 0;
}
.match_works .user_avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
}
.match_works .user_authorName {
    display: inline-block;
    padding: 0 5px;
}
.match_works .works_name {
    display: inline-block;
    padding: 0 5px;
}
.default  {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 400px;
    color: #8a8a8a;
    font-size: 15px;
    background-color: #fff;
}
.default  img {
    width: 80px;
}
@media (max-width: 767px){
    .match_ing_content .match_card {
        width: 100%;
        margin-bottom: 30px;
        background-color: #fff;
        cursor: pointer;
    }
    .match_finish .worksTab {
        flex-flow: wrap;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/match/matchList.vue